import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const TabsRow = styled.div`
  display: flex;
  gap: 1px;
`

export const TabItem = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${theme.spacing['2xl']};
  padding: ${theme.spacing.md};
  border-radius: ${theme.shapes.borderRadius.sm} ${theme.shapes.borderRadius.sm} 0 0;

  ${({ active, disabled }: { active: boolean; disabled: boolean }) => css`
    background: ${active ? theme.colors.neutral.clear : theme.colors.neutral.white};
    border-bottom: ${
      active ? `2px solid ${theme.colors.primary.main}` : `1px solid ${theme.colors.neutral.clear}`
    };

    pointer-events: ${disabled ? 'none' : 'auto'};
    color: ${
      disabled
        ? theme.colors.neutral.lighthover
        : active
          ? theme.colors.primary.main
          : theme.colors.neutral.high
    };
  `}
`

export const TabTitle = styled.p`
  margin: 0;
  color: inherit;
  font-family: ${theme.typography.family.bold};
  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.lg};
  line-height: ${theme.typography.lineHeight.md};
`
export const TabTotalizer = styled.span`
  margin-left: ${theme.spacing.xs};
  font-weight: ${theme.typography.weight.xsm};
  color: ${theme.colors.neutral.mediumhover};
  font-size: ${theme.typography.sizes.xs};
  font-family: ${theme.typography.family.primary};
`
export const ContentContainer = styled.div`
  padding: ${theme.spacing.xm};
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
  border-top-left-radius: 0;
`
